<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @showDetail="showDetail"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <Detail
      :visible.sync="detailVisible"
      :subsOrderEventLogCode="subsOrderEventLogCode"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import Detail from '../detail'

export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, Detail },
  data() {
    return { usePage: true, detailVisible: false, subsOrderEventLogCode: '' }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomPlatformSubsOrderEvnetLogsListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    showDetail(subsOrderEventLogCode) {
      this.detailVisible = true
      this.subsOrderEventLogCode = subsOrderEventLogCode
    },
  },
}
</script>
